import { render, staticRenderFns } from "./StakeholdersAdd.vue?vue&type=template&id=1f53d24e"
import script from "./StakeholdersAdd.vue?vue&type=script&lang=js"
export * from "./StakeholdersAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports